import React, { useEffect, useState } from "react";
import Popup from "../../../components/Popups/Popup";
import WorkflowTaskControl from "../../Workflow/Controls/WorkflowTaskControl";

interface PopupProps {
    show: boolean
    onHide: (submittedTaskIds: number[]) => void
    workflowTaskId: number
}

const WorkflowTaskPopup: React.FC<PopupProps> = ({ show, onHide, workflowTaskId }) => {
    const [taskId, setTaskId] = useState(workflowTaskId)
    const [submittedTaskIds, setSubmittedTaskIds] = useState<number[]>([])

    useEffect(() => {
        if (workflowTaskId)
            setTaskId(workflowTaskId)
    }, [workflowTaskId])

    function onTaskSubmited(newTaskId?: number) {
        setSubmittedTaskIds(x => [...x, taskId])
        if (newTaskId)
            setTaskId(newTaskId);
        else {
            submittedTaskIds.push(taskId)
            onHide(submittedTaskIds);
        }
    }

    function hide() {
        if (onHide)
            onHide(submittedTaskIds);
    }

    return (
        <Popup show={show} onHide={hide} size={'xxl'} title={'Workflow task'} >
            <Popup.Body>
                <WorkflowTaskControl taskId={taskId} onTaskSubmitted={onTaskSubmited} />
            </Popup.Body>
        </Popup>
    );
}
export default WorkflowTaskPopup;